import React, { useEffect, useState } from "react";
import DownloadButton from "components/DownloadButton";
import SideModal from "components/SideModal";
import TwoCellRow from "components/TwoCellRow";
import UserSvg from "assets/images/svg/user.svg";
import UserKycSvg from "assets/images/svg/user-kyc.svg";
import Phone from "assets/images/svg/phone.svg";
import { useFormattedMessage } from "hooks";
import { getGenders, getTitles } from "utils";
import { getDocumentsHost } from "common/helper";
import { fetchUmbrellaUserByID } from "api";
import { sendFormError } from "i18n/messages/errors";
import { UMBRELLA_STATUS } from "constants/status";
import NewLoader from "components/NewLoader";
import { createStructuredSelector } from "reselect";
import { selectLocale } from "store/app/selectors";
import { connect } from "react-redux";
import { getTranslatedCountriesList } from "constants";
import { fetchKYCStartFromAdmin } from "store/user/kyc/actions";
import { selectAdminKYCLoading, selectAdminKYCProviderData } from "store/user/kyc/selectors";

const messages = {
    sendFormError,
    identificationData: "meta_title_personal_data_page",
    kycData: "kyc_data",
    phonePlaceholder: "phone_placeholder",
    reject: "reject",
    approveUser: "approve_user",
};

const DOCUMENT_HOST = getDocumentsHost();

const WrappedUserSideModal = ({
    userId,
    open,
    onCloseButtonClick = () => {},
    onRejectClicked = () => {},
    onConfirm = () => {},
    setSelectedUserId = () => {},
    isRejecting,
    isApproving,
    requestError,
    errorUsersList,
    locale,
    fetchUmbrellaUserKYC,
    selectedUmbrellaUserLoading,
    selectedUmbrellaUserKYCProviderData,
}) => {
    const { formatMessage } = useFormattedMessage();
    const [isLoading, setLoading] = useState(false);

    const [userData, setUserData] = useState(null);
    const [userAddress, setUserAddress] = useState(null);

    const genders = getGenders(formatMessage);
    const title = getTitles(formatMessage);

    // get umbrella single user function
    const fetchUmbrellaUser = (id) => {
        setLoading(true);
        fetchUmbrellaUserByID(id)
            .then((res) => {
                const {
                    data: {
                        data: {
                            user: { user },
                        },
                    },
                } = res;

                user.uuid && fetchUmbrellaUserKYC(user.uuid);

                setUserData(user);
            })
            .catch((err) => {
                console.error(err, "error");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        setUserData(null);
        if (userId) {
            fetchUmbrellaUser(userId);
        }
    }, [userId]);

    useEffect(() => {
        if (userData?.Address) {
            setUserAddress(userData?.Address[0]);
        }
    }, [userData]);

    return (
        <SideModal
            className="editable-modal admin-tipster-modal"
            open={open}
            onCloseButtonClick={() => onCloseButtonClick()}
            containerClassName="mw-100 px-5 pt-10"
            heading="User details"
            isHeading
        >
            {isLoading || selectedUmbrellaUserLoading ? (
                <NewLoader type="primary" className="editable-modal-loader" />
            ) : (
                <>
                    <div className="menu-tab mb-6">
                        <TwoCellRow
                            containerClassname="w-90 my-4 mx-3"
                            rClassname="change primary-color text-16 d-block"
                            renderLeft={() => (
                                <span className="flex align-center text-14 fw-600 user-svg">
                                    <UserSvg />
                                    &nbsp;<span className="ml-2">{formatMessage(messages.identificationData)}</span>
                                </span>
                            )}
                        />
                        <TwoCellRow
                            removeRClass
                            lClassname={"text-14 fw-500"}
                            containerClassname="w-90 mb-4 mx-4"
                            left={`${
                                genders.find((item) => userData?.TypeGender !== "" && userData?.TypeGender === item.value)
                                    ?.label || ""
                            } ${
                                title.find((item) => userData?.TypeTitle !== "" && userData?.TypeTitle === item.value)?.label ||
                                ""
                            }`}
                        />
                        <TwoCellRow
                            removeRClass
                            lClassname={"text-14 fw-500"}
                            containerClassname="w-90 mb-4 mx-4"
                            left={`${userData?.FirstName} ${userData?.LastName}`}
                        />
                        <TwoCellRow
                            removeRClass
                            lClassname={`text-14 fw-500 ${
                                userAddress?.Street || userAddress?.Streetnumber || userAddress?.StreetAddition
                                    ? ""
                                    : "another-grey-color"
                            }`}
                            containerClassname="w-90 mb-4 mx-4"
                            left={
                                userAddress?.Street || userAddress?.Streetnumber || userAddress?.StreetAddition
                                    ? `${userAddress?.Street} ${userAddress?.Streetnumber} ${userAddress?.StreetAddition}`
                                    : `Street Address`
                            }
                        />
                        <TwoCellRow
                            removeRClass
                            lClassname={`text-14 fw-500 ${userAddress?.Zipcode || userAddress?.City ? "" : "another-grey-color"}`}
                            containerClassname={`w-90 mb-4 mx-4`}
                            left={
                                userAddress?.Zipcode || userAddress?.City
                                    ? `${userAddress?.Zipcode} ${userAddress?.City || ""}`
                                    : "City"
                            }
                        />
                        <TwoCellRow
                            removeRClass
                            lClassname={`text-14 fw-500 ${userAddress?.Country ? "" : "another-grey-color"}`}
                            containerClassname={`w-90 mb-4 mx-4`}
                            left={
                                getTranslatedCountriesList(locale)?.find((item) => item.value === userAddress?.Country)?.label ||
                                "Country"
                            }
                        />
                        <TwoCellRow
                            removeRClass
                            lClassname={"text-14 fw-500"}
                            containerClassname="w-90 mb-4 mx-4"
                            left={userData?.Email}
                        />
                        <TwoCellRow
                            removeRClass
                            lClassname={`text-14 fw-500 ${userData?.Identification?.Birthplace ? "" : "another-grey-color"}`}
                            containerClassname="w-90 mb-4 mx-4"
                            left={userData?.Identification?.Birthplace || "Birthplace"}
                        />

                        <TwoCellRow
                            removeRClass
                            lClassname={`text-14 fw-500 ${userData?.Identification?.Birthname ? "" : "another-grey-color"}`}
                            containerClassname="w-90 mb-4 mx-4"
                            left={userData?.Identification?.Birthname || "Birthname"}
                        />
                        <TwoCellRow
                            removeRClass
                            lClassname={`text-14 fw-500 ${userData?.Identification?.BirthCountry ? "" : "another-grey-color"}`}
                            containerClassname="w-90 mb-4 mx-4"
                            left={
                                getTranslatedCountriesList(locale)?.find(
                                    (item) => item.value === userData?.Identification?.BirthCountry
                                )?.label || "BirthCountry"
                            }
                        />
                    </div>
                    <div className="menu-tab mb-6">
                        <TwoCellRow
                            containerClassname="w-90 my-4 mx-3"
                            rClassname="change primary-color text-16 d-block"
                            renderLeft={() => (
                                <span className="flex align-center text-14 fw-600 user-svg">
                                    <UserKycSvg />
                                    &nbsp;<span className="ml-2">{formatMessage(messages.kycData)}</span>
                                </span>
                            )}
                        />
                        <TwoCellRow
                            removeRClass
                            lClassname={"text-14 fw-500"}
                            containerClassname={`w-90 mb-4 mx-4 
                                    ${
                                        title.find(
                                            (item) =>
                                                selectedUmbrellaUserKYCProviderData?.Title !== "" &&
                                                selectedUmbrellaUserKYCProviderData?.Title === item.value
                                        )?.label ||
                                        genders.find(
                                            (item) =>
                                                selectedUmbrellaUserKYCProviderData?.Gender !== "" &&
                                                selectedUmbrellaUserKYCProviderData?.Gender === item.value
                                        )?.label
                                            ? ""
                                            : "another-grey-color"
                                    }`}
                            left={`${
                                genders.find(
                                    (item) =>
                                        selectedUmbrellaUserKYCProviderData?.Gender !== "" &&
                                        selectedUmbrellaUserKYCProviderData?.Gender === item.value
                                )?.label || ""
                            } ${
                                title.find(
                                    (item) =>
                                        selectedUmbrellaUserKYCProviderData?.Title !== "" &&
                                        selectedUmbrellaUserKYCProviderData?.Title === item.value
                                )?.label || ""
                            }`}
                        />
                        <TwoCellRow
                            removeRClass
                            lClassname={"text-14 fw-500"}
                            containerClassname="w-90 mb-4 mx-4"
                            left={`${selectedUmbrellaUserKYCProviderData?.Firstname} ${selectedUmbrellaUserKYCProviderData?.Lastname}`}
                        />
                        <TwoCellRow
                            removeRClass
                            lClassname={"text-14 fw-500"}
                            containerClassname="w-90 mb-4 mx-4"
                            left={`${selectedUmbrellaUserKYCProviderData?.Street} ${selectedUmbrellaUserKYCProviderData?.StreetNumber}`}
                        />

                        <TwoCellRow
                            removeRClass
                            lClassname={`text-14 fw-500 ${
                                selectedUmbrellaUserKYCProviderData?.City || selectedUmbrellaUserKYCProviderData?.Zipcode
                                    ? ""
                                    : "another-grey-color"
                            }`}
                            containerClassname="w-90 mb-4 mx-4"
                            left={`${
                                selectedUmbrellaUserKYCProviderData?.Zipcode || selectedUmbrellaUserKYCProviderData?.City
                                    ? `${selectedUmbrellaUserKYCProviderData?.Zipcode} ${
                                          selectedUmbrellaUserKYCProviderData?.City || ""
                                      }`
                                    : "City"
                            }`}
                        />
                        <TwoCellRow
                            removeRClass
                            lClassname={`text-14 fw-500 ${
                                selectedUmbrellaUserKYCProviderData?.Country ? "" : "another-grey-color"
                            }`}
                            containerClassname="w-90 mb-4 mx-4"
                            left={
                                getTranslatedCountriesList(locale)?.find(
                                    (item) => item.value === selectedUmbrellaUserKYCProviderData?.Country
                                )?.label || "Country"
                            }
                        />

                        <TwoCellRow
                            removeRClass
                            lClassname={`text-14 fw-500 ${userData?.Email ? "" : "another-grey-color"}`}
                            containerClassname="w-90 mb-4 mx-4"
                            left={userData?.Email || "Email"}
                        />
                        <TwoCellRow
                            removeRClass
                            lClassname={`text-14 fw-500 ${
                                selectedUmbrellaUserKYCProviderData?.BirthDay ? "" : "another-grey-color"
                            }`}
                            containerClassname="w-90 mb-4 mx-4"
                            left={selectedUmbrellaUserKYCProviderData?.BirthDay || "BirthDay"}
                        />
                        <TwoCellRow
                            removeRClass
                            lClassname={`text-14 fw-500 ${
                                selectedUmbrellaUserKYCProviderData?.BirthPlace ? "" : "another-grey-color"
                            }`}
                            containerClassname="w-90 mb-4 mx-4"
                            left={selectedUmbrellaUserKYCProviderData?.BirthPlace || "BirthPlace"}
                        />
                        <TwoCellRow
                            removeRClass
                            lClassname={`text-14 fw-500 ${
                                selectedUmbrellaUserKYCProviderData?.BirthName ? "" : "another-grey-color"
                            }`}
                            containerClassname="w-90 mb-4 mx-4"
                            left={selectedUmbrellaUserKYCProviderData?.BirthName || "BirthName"}
                        />
                        <TwoCellRow
                            removeRClass
                            lClassname={`text-14 fw-500 ${userData?.Identification?.BirthCountry ? "" : "another-grey-color"}`}
                            containerClassname="w-90 mb-4 mx-4"
                            left={
                                getTranslatedCountriesList(locale)?.find(
                                    (item) => item.value === userData?.Identification?.BirthCountry
                                )?.label || "BirthCountry"
                            }
                        />
                        <TwoCellRow
                            removeRClass
                            lClassname={`text-14 fw-500 ${
                                selectedUmbrellaUserKYCProviderData?.IDDocumentNumber ? "" : "another-grey-color"
                            }`}
                            containerClassname="w-90 mb-4 mx-4"
                            left={selectedUmbrellaUserKYCProviderData?.IDDocumentNumber || "ID Document Number"}
                        />
                        <h6 className="mb-4 mx-4">Identification</h6>
                        <DownloadButton
                            isToken
                            className="mx-4"
                            fileURL={`${DOCUMENT_HOST}/download/${selectedUmbrellaUserKYCProviderData?.IDPDFPath}$`}
                            title="KYC document"
                        />
                    </div>
                    {userData?.Phone?.[0] && (
                        <div className="menu-tab mb-10">
                            <TwoCellRow
                                containerClassname="w-90 my-4 mx-3"
                                rClassname="change primary-color text-16 d-block"
                                renderLeft={() => (
                                    <span className="flex align-center text-14 fw-600 user-svg">
                                        <Phone />
                                        &nbsp;<span className="ml-2">{formatMessage(messages.phonePlaceholder)}</span>
                                    </span>
                                )}
                            />
                            <TwoCellRow
                                removeRClass
                                lClassname={"text-14 fw-500"}
                                containerClassname="w-90 mb-4 mx-4"
                                left={`+${userData?.Phone[0]?.DialCode} ${userData?.Phone[0]?.Number}`}
                            />
                        </div>
                    )}
                    {userData?.StatusUmbrellaClearance === "" ||
                    userData?.StatusUmbrellaClearance === UMBRELLA_STATUS.PENDING ||
                    userData?.StatusUmbrellaClearance === UMBRELLA_STATUS.RECLEARANCE ? (
                        <>
                            {requestError ? (
                                <span className="error pl-0 mb-4 d-inline-block">{formatMessage(messages["sendFormError"])}</span>
                            ) : (
                                errorUsersList &&
                                Object.entries(errorUsersList)?.map((item, index) => {
                                    return (
                                        <span
                                            key={`error-${index}`}
                                            className="text-left text-16 fw-500 text-left error pl-0 mb-4 mw-100 d-inline-block"
                                        >
                                            {item[0]}
                                        </span>
                                    );
                                })
                            )}
                            <button
                                disabled={isApproving}
                                className="text-16 mb-4"
                                onClick={() => {
                                    onConfirm();
                                    setSelectedUserId([userData.uid]);
                                }}
                            >
                                {isApproving ? <NewLoader /> : formatMessage(messages.approveUser)}
                            </button>
                            <button
                                disabled={isRejecting}
                                className="text-16 secondary"
                                onClick={() => {
                                    onRejectClicked();
                                    setSelectedUserId([userData.uid]);
                                }}
                            >
                                {isRejecting ? <NewLoader /> : formatMessage(messages.reject)}
                            </button>
                        </>
                    ) : null}
                </>
            )}
        </SideModal>
    );
};

const mapStateToProps = createStructuredSelector({
    locale: selectLocale,
    selectedUmbrellaUserLoading: selectAdminKYCLoading,
    selectedUmbrellaUserKYCProviderData: selectAdminKYCProviderData,
});

const mapDispatchToProps = (dispatch) => ({
    fetchUmbrellaUserKYC: (value) => dispatch(fetchKYCStartFromAdmin(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WrappedUserSideModal);
